// 本地存储工具类，用于替换 uni.getStorageSync 和 uni.setStorageSync
export default {
  getItem(key) {
    try {
      const value = localStorage.getItem(key)
      return value ? JSON.parse(value) : null
    } catch (e) {
      return localStorage.getItem(key)
    }
  },
  setItem(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch (e) {
      localStorage.setItem(key, value)
    }
  },
  removeItem(key) {
    localStorage.removeItem(key)
  },
  clear() {
    localStorage.clear()
  }
}




